import { useId, type SVGProps } from "react";
import { cn } from "@/lib/utils";

/** A hand-drawn underline, used sparingly on the page's key phrases. */
export function OrganicUnderline({ className, ...props }: SVGProps<SVGSVGElement>) {
  const clipId = `organic-underline-${useId().replaceAll(":", "")}`;

  return (
    <svg
      aria-hidden
      viewBox="0 0 300 18"
      preserveAspectRatio="none"
      className={cn("organic-underline", className)}
      {...props}
    >
      <defs>
        <clipPath id={clipId} clipPathUnits="userSpaceOnUse">
          <rect x="0" y="0" width="300" height="18" className="organic-line-reveal organic-underline-reveal" />
        </clipPath>
      </defs>
      <path
        pathLength={1}
        d="M2 12 C60 4 120 16 180 8 S280 6 298 11"
        fill="none"
        stroke="currentColor"
        strokeWidth="4"
        strokeLinecap="round"
        vectorEffect="non-scaling-stroke"
        clipPath={`url(#${clipId})`}
        className="organic-underline-path"
      />
    </svg>
  );
}

/** The rolling ground line the page cuts between its ground colors, as the
    wavy edge of a paper band: fill below the swell, the field shows above. */
export function GroundWave({ className, ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      aria-hidden
      viewBox="0 0 1440 64"
      preserveAspectRatio="none"
      className={cn("ground-wave", className)}
      {...props}
    >
      <path
        d="M0 42 C180 14 420 58 720 40 C1020 22 1240 54 1440 24 L1440 64 L0 64 Z"
        fill="var(--paper)"
      />
    </svg>
  );
}

/** The page resurfaces through rolling ground instead of a straight color cut. */
export function TerrainHorizon({ className, ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      aria-hidden
      viewBox="0 0 1440 72"
      preserveAspectRatio="none"
      className={cn("terrain-horizon", className)}
      {...props}
    >
      <path
        d="M0 0 H1440 V28 C1230 52 1020 14 760 32 C500 50 230 58 0 24 Z"
        fill="var(--field-deep)"
      />
      <path
        d="M0 24 C230 58 500 50 760 32 C1020 14 1230 52 1440 28 V38 C1220 62 1010 25 760 42 C510 59 235 65 0 33 Z"
        fill="#8b9c82"
        opacity="0.82"
      />
      <path
        d="M0 33 C235 65 510 59 760 42 C1010 25 1220 62 1440 38 V45 C1215 69 1000 34 760 50 C520 66 240 70 0 41 Z"
        fill="#d8d7bd"
        opacity="0.88"
      />
    </svg>
  );
}
